import _newsDataState from "./newsDataState";
import _scrollFixed from "./scrollFixed";

export const newsDataState = _newsDataState;
export const scrollFixed = _scrollFixed;